export default __webpack_public_path__ + "static/media/video-2.9d559927.png";